module.exports = __webpack_public_path__ + "img/logo_halosenja.2a32170c.png";